/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export class CustomTranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }

  getTranslation(lang: string): Observable<any> {
    // Load the JSON translations
    lang = lang.match(/en|es/) ? lang : 'en';

    const jsonTranslations$ = this.http.get<any>(`./assets/i18n/${lang}.json`);

    // Combine JSON and text file results
    return forkJoin({ json: jsonTranslations$ }).pipe(
      map((response) => {
        // Merge JSON translations with the disclaimer text
        return {
          ...response.json,
        };
      }),
    );
  }
}
export function createTranslationLoader(http: HttpClient) {
  return new CustomTranslationLoader(http);
}
